import { redirectDocument } from 'react-router';

import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { cmsApiServerFetchFile } from '#/modules/cms/files/api/cmsApiFetchFile';
import { cmsViewFilePath } from '#/modules/cms/files/routing/cmsFiles.paths';
import { DynamicNotFoundPage } from '#/pages/NotFound/DynamicNotFoundPage';
import type { RoutePathLoaderArgs } from '#/routing/classes/types/RoutePathLoaderArgs';
import type { RouteProps } from '#/routing/types/RouteProps';
import { idealistNotFound } from '#/routing/utils/idealistNotFound';

import { CmsViewFilePage } from './CmsViewFile.page';

export async function loader({
  request,
  url,
  context,
  params: { '*': filename },
}: RoutePathLoaderArgs<typeof cmsViewFilePath>) {
  const { download } = cmsViewFilePath.searchParamsFromUrl(url);

  const fileDetails = await cmsApiServerFetchFile({ request, context })(
    filename,
    download === 'true',
  ).catch(() => null);

  if (!fileDetails) return idealistNotFound({ filename: null });

  return fileDetails.displayPdf
    ? { filename }
    : redirectDocument(fileDetails.url, { status: 302 /* HTTP_FOUND */ });
}

export default function CmsViewFileRoute({
  loaderData: { filename },
}: RouteProps<typeof loader>) {
  const { i18n } = useI18n();

  if (!filename) return <DynamicNotFoundPage />;

  return (
    <RouteModule title={i18n('Documents')}>
      <CmsViewFilePage filename={filename} />
    </RouteModule>
  );
}
